import { render } from "./DisclaimerTos.vue?vue&type=template&id=b7feddba"
import script from "./DisclaimerTos.vue?vue&type=script&lang=js"
export * from "./DisclaimerTos.vue?vue&type=script&lang=js"

import "./DisclaimerTos.vue?vue&type=style&index=0&id=b7feddba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__